if (!window.Organax2026HomeBound) {
  window.Organax2026HomeBound = true;

  const activateTab = (tab, moveFocus = true) => {
    const list = tab.closest('[role="tablist"]');
    const section = list && list.closest('section');
    if (!section) return;
    if (tab.classList.contains('organax-2026-category__tab')) {
      activateCategory(tab);
      if (moveFocus) tab.focus();
      return;
    }
    list.querySelectorAll('[role="tab"]').forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      const panel = section.querySelector('#' + CSS.escape(item.getAttribute('aria-controls')));
      if (panel) {
        const wasHidden = panel.hidden;
        if (active) {
          const storedProducts = panel.querySelector('template[data-organax-products]');
          if (storedProducts) storedProducts.replaceWith(storedProducts.content);
        }
        panel.hidden = !active;
        panel.classList.remove('is-entering');
        if (active && wasHidden && tab.classList.contains('organax-2026-products__tab') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          // Restart the entrance on every switch, including a quick return to a prior tab.
          void panel.offsetWidth;
          panel.classList.add('is-entering');
          panel.addEventListener('animationend', () => panel.classList.remove('is-entering'), { once: true });
        }
      }
    });
    const viewAllUrl = tab.dataset.viewAllUrl;
    if (viewAllUrl) section.querySelectorAll('[data-organax-view-all]').forEach((link) => { link.href = viewAllUrl; });
    if (moveFocus) tab.focus();
  };

  const categoryStates = new WeakMap();
  const warmCategoryImage = async (panel) => {
    const image = panel?.querySelector('.organax-2026-category__image-link img');
    if (!image) return;
    image.loading = 'eager';
    if (image.complete && image.naturalWidth) return;
    await image.decode();
  };
  const activateCategory = (link) => {
    const section = link.closest('.organax-2026-category');
    if (!section) return;
    const panel = document.getElementById(link.dataset.organaxCategoryTarget || link.getAttribute('aria-controls'));
    if (!panel) return;
    const state = categoryStates.get(section) || { version: 0 };
    categoryStates.set(section, state);
    const version = ++state.version;
    clearTimeout(state.hoverTimer);
    state.hoverTimer = setTimeout(async () => {
      try { await warmCategoryImage(panel); } catch { return; }
      if (version !== state.version || !section.isConnected) return;
      clearTimeout(state.transitionTimer);
      section.querySelectorAll('.organax-2026-category__panel').forEach(item => {
        item.classList.remove('is-entering');
        if (item !== panel && item !== state.current) item.hidden = true;
      });
      const previous = state.current || section.querySelector('.organax-2026-category__panel:not([hidden])');
      state.current = panel;
      panel.hidden = false;
      section.querySelectorAll('.organax-2026-category__tab').forEach(item => {
        const active = item === link;
        item.classList.toggle('is-active', active);
        item.closest('.organax-2026-category__row')?.classList.toggle('is-active', active);
        if (item.getAttribute('role') === 'tab') {
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        }
      });
      const finish = () => {
        if (state.current !== panel) return;
        section.querySelectorAll('.organax-2026-category__panel').forEach(item => { item.hidden = item !== panel; });
        panel.classList.remove('is-entering');
      };
      if (previous !== panel && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        panel.classList.add('is-entering');
        state.transitionTimer = setTimeout(finish, 320);
      } else finish();
      // At most one adjacent image is warmed, only after a deliberate selection.
      const next = panel.nextElementSibling;
      if (!navigator.connection?.saveData && next?.classList.contains('organax-2026-category__panel')) warmCategoryImage(next).catch(() => {});
    }, 70);
  };
  const prepareCategories = (root) => {
    root.querySelectorAll('.organax-2026-category').forEach(section => {
      if (section.dataset.imagesPrepared) return;
      section.dataset.imagesPrepared = 'true';
      const prepare = () => {
        if (!matchMedia('(min-width: 750px)').matches || navigator.connection?.saveData) return;
        const first = section.querySelector('.organax-2026-category__panel:not([hidden])');
        warmCategoryImage(first).then(() => warmCategoryImage(first?.nextElementSibling)).catch(() => {});
      };
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        prepare();
      }, { rootMargin: '250px' });
      observer.observe(section);
    });
  };
  prepareCategories(document);
  document.addEventListener('shopify:section:load', event => prepareCategories(event.target));
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch' || !matchMedia('(min-width: 750px)').matches) return;
    const text = event.target.closest('[data-organax-category-text]');
    if (!text || text.contains(event.relatedTarget)) return;
    const link = text.closest('[data-organax-category-target]');
    if (link) activateCategory(link);
    const tab = text.closest('.organax-2026-category__tab[role="tab"]');
    if (tab) activateTab(tab, false);
  });
  document.addEventListener('focusin', (event) => {
    const link = event.target.closest('[data-organax-category-target]');
    if (link) activateCategory(link);
  });

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.organax-2026-category__tab[role="tab"], .organax-2026-products__tab');
    if (tab) { activateTab(tab); return; }
    const arrow = event.target.closest('[data-organax-scroll]');
    if (!arrow) return;
    const section = arrow.closest('section');
    const rail = section && section.querySelector('.organax-2026-products__panel:not([hidden]) .organax-2026-products__rail');
    if (!rail) return;
    const card = rail.querySelector('.organax-2026-products__card');
    const step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).gap) || 0) : rail.clientWidth;
    rail.scrollBy({ left: step * (arrow.dataset.organaxScroll === 'next' ? 1 : -1), behavior: 'smooth' });
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('.organax-2026-category__tab[role="tab"], .organax-2026-products__tab');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    activateTab(tabs[next]);
  });
}
